<template>
  <section>
    <form
      :aria-busy="loading ? 'true' : 'false'"
      :data-busy-message="dataBusyMessage"
      @submit.prevent="validateForm"
    >
      <template v-if="!isTicket">
        <div class="candidate-amount-select">
          <h3 v-if="amount">
            Valor escolhido: <strong>R$ {{ amount | formatBRL }},00</strong>
          </h3>
        </div>
        <h4 v-if="allowedPaymentMethods.length > 1">
          Escolha forma de pagamento
        </h4>
        <div
          :class="`input-wrapper half
          ${validation.errors.payment_method ? 'has-error' : ''}`"
        >
          <ul class="payment-choices">
            <li
              v-if="isPaymentMethodAllowed('credit_card')"
              class="payment-type"
            >
              <input
                id="credit_card"
                v-model="payment_method"
                v-focus
                name="payment_method"
                value="credit_card"
                type="radio"
              >
              <label for="credit_card">{{ 'creditCard' | translate }}</label>
            </li>
            <li
              v-if="isPaymentMethodAllowed('boleto')"
              class="payment-type"
            >
              <input
                id="boleto"
                v-model="payment_method"
                name="payment_method"
                value="boleto"
                type="radio"
              >
              <label for="boleto">{{ 'boleto' | translate }}</label>
            </li>
          </ul>
        </div>
      </template>
      <fieldset>
        <h4>Informe seus dados pessoais</h4>
        <div
          :class="`input-wrapper half
					${validation.errors.name ? 'has-error' : ''}`"
        >
          <label for="name">Primeiro nome</label>
          <input
            v-model="name"
            v-focus="isTicket"
            type="text"
            name="name"
            required
          >
          <div
            v-if="validation.errors.name"
            class="error"
          >
            {{ validation.errors.name }}
          </div>
        </div>
        <div
          :class="`input-wrapper half
					${validation.errors.surname ? 'has-error' : ''}`"
        >
          <label for="surname">Sobrenome</label>
          <input
            v-model="surname"
            type="text"
            name="surname"
            required
          >
          <div
            v-if="validation.errors.surname"
            class="error"
          >
            {{ validation.errors.surname }}
          </div>
        </div>
        <div
          :class="`input-wrapper
					${validation.errors.cpf ? 'has-error' : ''}`"
        >
          <label for="cpf">CPF</label>
          <input
            v-model="cpf"
            v-mask="'###.###.###-##'"
            type="tel"
            name="cpf"
            required
          >
          <div
            v-if="validation.errors.cpf"
            class="error"
          >
            {{ validation.errors.cpf }}
          </div>
        </div>
        <div
          :class="`input-wrapper
					${validation.errors.email ? 'has-error' : ''}`"
        >
          <label for="email">Email</label>
          <input
            v-model="email"
            type="email"
            name="email"
            required
          >
          <div
            v-if="validation.errors.email"
            class="error"
          >
            {{ validation.errors.email }}
          </div>
        </div>
      </fieldset>
      <template v-if="!isTicket">
        <div
          v-if="candidateAmount"
          class="candidate-amount"
        >
          <p>{{ 'donationValue' | translate }} {{ 'currencyReal' | translate }}{{ candidateAmount | formatBRLDec }}</p>
        </div>
        <div v-if="payment_method === 'credit_card'">
          <p class="form__disclaimer">
            Taxa de {{ creditCard }} via cartão de crédito. Esse valor é destinado a taxas de operação financeira, sistemas de controle anti-fraude, impostos e infraestrutura.
          </p>
        </div>
        <div v-if="payment_method === 'boleto'">
          <p class="form__disclaimer">
            Taxa de {{ paymentSlip }} via boleto. Esse valor é destinado a taxas de operação financeira, sistemas de controle anti-fraude, impostos e infraestrutura.
          </p>
        </div>
      </template>
      <p
        v-if="errorMessage != ''"
        class="error"
      >
        {{ errorMessage }}
      </p>
      <div
        v-if="validation.errors.payment_method"
        class="error"
      >
        • {{ 'paymentMethodError' | translate }}
      </div>
      <a
        class="donation-nav donation-nav--rewind"
        href="#"
        @click.prevent="goBack"
      >voltar</a>
      <button
        type="submit"
        :disabled="loading"
        class="donation-nav donation-nav--forward"
      >
        Continuar
      </button>
    </form>
  </section>
</template>

<script>
	import { formatBRLDec, formatBRL } from '../../utilities';

	import CONFIG from "./../../../config.js";

  import { mapMutations } from 'vuex';

  import {
    mask
  } from "vue-the-mask";
  import {
    validate
  } from "../../utilities";

  const Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    encode: function(e) {
      let t = "";
      let n, r, i, s, o, u, a;
      let f = 0;
      e = Base64._utf8_encode(e);
      while (f < e.length) {
        n = e.charCodeAt(f++);
        r = e.charCodeAt(f++);
        i = e.charCodeAt(f++);
        s = n >> 2;
        o = ((n & 3) << 4) | (r >> 4);
        u = ((r & 15) << 2) | (i >> 6);
        a = i & 63;
        if (isNaN(r)) {
          u = a = 64;
        } else if (isNaN(i)) {
          a = 64;
        }
        t =
          t +
          this._keyStr.charAt(s) +
          this._keyStr.charAt(o) +
          this._keyStr.charAt(u) +
          this._keyStr.charAt(a);
      }
      return t;
    },
    _utf8_encode: function(e) {
      e = e.replace(/rn/g, "n");
      let t = "";
      for (let n = 0; n < e.length; n++) {
        const r = e.charCodeAt(n);
        if (r < 128) {
          t += String.fromCharCode(r);
        } else if (r > 127 && r < 2048) {
          t += String.fromCharCode((r >> 6) | 192);
          t += String.fromCharCode((r & 63) | 128);
        } else {
          t += String.fromCharCode((r >> 12) | 224);
          t += String.fromCharCode(((r >> 6) & 63) | 128);
          t += String.fromCharCode((r & 63) | 128);
        }
      }
      return t;
    }
  };

  export default {
    name: "UserData",
    directives: {
      mask
    },
    props: {
      isTicket: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        creditCard: CONFIG.taxes.CREDIT_CARD_TEXT,
        paymentSlip: CONFIG.taxes.PAYMENT_SLIP_TEXT,
        creditCardTaxPercent: CONFIG.taxes.CREDIT_CARD_TAX_PERCENT,
        paymentSlipTaxPercent: CONFIG.taxes.PAYMENT_SLIP_TAX_PERCENT,
        creditCardTax: CONFIG.taxes.CREDIT_CARD_TAX,
        paymentSlipTax: CONFIG.taxes.PAYMENT_SLIP_TAX,

        loading: false,
        dataBusyMessage: '',
        errorMessage: "",
        name: "",
        surname: "",
        cpf: "",
        email: "",
        payment_method: "",
        donationFp: "",
        validation: {
          errors: {}
        },
        formData: {}
      };
    },
    computed: {
      candidate() {
        return this.getMergeCandidate.candidate;
      },
      getMergeCandidate() {
        return this.$store.getters.generateCandidateObject;
      },
      amount() {
        return this.$store.state.amount;
      },
      token() {
        return this.$store.state.token;
      },
      candidateId() {
        return this.$store.state.candidateId;
      },
      getAddress() {
        return this.$store.state.userData;
      },
      candidateAmount() {
      let newAmount = null;
        if (this.payment_method === 'credit_card') {
          newAmount = this.amount - this.amount * this.creditCardTaxPercent;
          newAmount = newAmount - this.creditCardTax;
        }
        else if (this.payment_method === 'boleto') {
          newAmount = this.amount - this.amount * this.paymentSlipTaxPercent;
          newAmount = newAmount - this.paymentSlipTax;
        }
        if (newAmount) {
          return Math.floor(newAmount).toFixed(0);
        }
      },
      allowedPaymentMethods() {
        const allowedMethods = (this.candidate || {}).allowed_payment_methods || ['credit_card', 'boleto'];

        if(allowedMethods.length === 1) {
          this.payment_method = allowedMethods[0];
        }

        return allowedMethods;
      }
    },
    watch: {
      payment_method(newValue, oldValue) {
        if (newValue && !oldValue) {
          if (this.validation.errors.payment_method) {
            this.validation.errors.payment_method = undefined;
          }
        }
      }
    },
    methods: {
      isPaymentMethodAllowed(method = '') {
        return this.allowedPaymentMethods.indexOf(method.toLowerCase()) !== -1;
      },

      goBack() {
        if (!this.isTicket) {
          this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'selectValue' });
        } else {
          this.SET_TICKET_STEP({ step: 'intro' });
        }
      },

      scrollToForm() {
        const form = this.isTicket
          ? document.getElementById('votar')
          : document.getElementById('doar');
        form.scrollIntoView({ block: 'start', behavior: 'smooth' });
      },

      toggleLoading(message = '') {
        this.loading = !this.loading;

        this.dataBusyMessage = this.dataBusyMessage !== message
          ? message
          : '';
      },

      validateForm() {
        this.toggleLoading('Validando valor e método...');

        const {
          payment_method,
          name,
          surname,
          cpf,
          email
        } = this;

        const fields = {
          name,
          surname,
          cpf,
          email
        };

        if (!this.isTicket) fields.payment_method = payment_method;

        const validation = validate(fields);

        if (validation.valid) {
          this.formData = fields;
          this.registerUser(fields);
          const name = `${this.name} ${this.surname}`
            .toUpperCase()
            .trim()
            .replace(/\s/g, "");
          const cpf = this.cpf.replace(/[^\d]+/g, "");
          let donerData = {
            name,
            cpf,
            email: this.email,
            firstName: this.name,
            surname: this.surname,
            cpfDirty: this.cpf,
            amount: this.amount,
          };

          let currentDonerData = sessionStorage.getItem('doner-data');

          if (currentDonerData) {
            currentDonerData = JSON.parse( currentDonerData );
            donerData = Object.assign( currentDonerData, donerData );
          }

          // ==  session storage data to ckeck user and cpf in credit card payment == /
          sessionStorage.setItem( "doner-data", JSON.stringify(donerData) );
        } else {
          this.validation = validation;
          this.toggleLoading();
        }
      },

      registerUser(data) {
        this.getDonationFP()
          .then(() => {
            this.setData(data);
          })
          .catch(error => {
            this.donationFp = Base64.encode(
              JSON.stringify({
                id: "error",
                msg: error.toString()
              })
            );
            this.setData(data);
          });
      },
      handleErrorMessage(err) {
        this.errorMessage = err.data[0].message;
      },
      controlSession() {
        const dataSession = JSON.parse(sessionStorage.getItem('doner-data'));
        if(dataSession != null){
          const data = {
              amount: (this.amount != undefined) ? this.amount : dataSession.amount,
              step: 'userData',
            };

          if(!this.isTicket) this.$store.dispatch('CHANGE_PAYMENT_AMOUNT', data);

          this.name = dataSession.firstName;
          this.surname = dataSession.surname;
          this.cpf = dataSession.cpf;
          this.email = dataSession.email;
        }
      },
      getDonationFP() {
        return new Promise((resolve, reject) => {
          const d1 = new Date();
          const fp = new VotolegalFP({
            excludeUserAgent: true,
            dontUseFakeFontInCanvas: true
          });

          fp.get((result, components) => {
            const d2 = new Date();

            const info = {
              ms: d2 - d1,
              id: result
            }

            for (let index in components) {
              const obj = components[index];

              if (obj.key == 'canvas' || obj.key == 'webgl') {
                info[obj.key] = obj.value.toString().length;
              } else {
                info[obj.key] = obj.value.toString();
              }
            }

            const Base64 = {
              _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
              encode: function (e) {
                let t = "";
                let n, r, i, s, o, u, a;
                let f = 0;
                e = Base64._utf8_encode(e);
                while (f < e.length) {
                  n = e.charCodeAt(f++);
                  r = e.charCodeAt(f++);
                  i = e.charCodeAt(f++);
                  s = n >> 2;
                  o = (n & 3) << 4 | r >> 4;
                  u = (r & 15) << 2 | i >> 6;
                  a = i & 63;
                  if (isNaN(r)) {
                    u = a = 64
                  } else if (isNaN(i)) {
                    a = 64
                  }
                  t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
                }
                return t
              },
              _utf8_encode: function (e) {
                e = e.replace(/rn/g, "n");
                let t = "";
                for (let n = 0; n < e.length; n++) {
                  const r = e.charCodeAt(n);
                  if (r < 128) {
                    t += String.fromCharCode(r)
                  } else if (r > 127 && r < 2048) {
                    t += String.fromCharCode(r >> 6 | 192);
                    t += String.fromCharCode(r & 63 | 128)
                  } else {
                    t += String.fromCharCode(r >> 12 | 224);
                    t += String.fromCharCode(r >> 6 & 63 | 128);
                    t += String.fromCharCode(r & 63 | 128)
                  }
                }
                return t
              }
            }

            const donation_fp = Base64.encode(JSON.stringify(info));

            if(donation_fp) {
              this.donationFp = donation_fp;
              resolve();
            } else {
              reject();
            }
          });
        });
      },

      setData(data) {
        const payload = {
          device_authorization_token_id: this.token,
          email: this.email,
          name: `${this.name} ${this.surname}`,
          cpf: this.cpf,
          candidate_id: this.candidateId,
          donation_fp: this.donationFp,
          referral_code: this.$store.state.referral,
        };

        if (!this.isTicket) {
          payload.payment_method = this.payment_method;
          payload.amount = this.amount;
        } else {
          payload.name = this.name;
          payload.surname = this.surname;
        }

        const user = {
          name: data.name,
          surname: data.surname,
        };

        this.$store.dispatch('SAVE_PAYMENT_DATA', payload);
        this.$store.dispatch('SAVE_USERNAME', user);

        if (!this.isTicket) {
          this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'boleto' });
        } else {
          this.SET_TICKET_STEP({step: 'addressData'});
        }
      },

      handleSession() {
        if (window.localStorage) {
          const tokenName = window.location.host === "votolegal.com.br" || window.location.host === "votolegal.com"
            ? "prod_vlm_token"
            : "dev_vlm_token";
          const token = localStorage.getItem(tokenName);
          if (token !== null) {
            this.$store.dispatch("ADD_TOKEN", token);
          } else {
            this.$store.dispatch("GET_TOKEN").then(res => {
              localStorage.setItem(
                tokenName,
                res.data.device_authorization_token_id
              );
            });
          }
        }
      },

      ...mapMutations([
        'SET_TICKET_STEP',
      ]),
		},
		mounted() {
			this.scrollToForm();
			this.handleSession();
			this.controlSession();
		},
	};
</script>



// WEBPACK FOOTER //
// _source/javascript/components/steps/userData.vue